import * as React from "react";
const SvgThumbsUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12.454 1.54a1.865 1.865 0 0 0-2.872.284L6.168 6.946 6.131 7H1v11h14.278a3 3 0 0 0 2.966-2.555l.9-6A3 3 0 0 0 16.178 6H13V2.86c0-.495-.197-.97-.546-1.32ZM8 16h7.278a1 1 0 0 0 .989-.851l.9-6A1 1 0 0 0 16.177 8H11V3.303l-3 4.5V16Zm-2 0V9H3v7h3Z",
      clipRule: "evenodd"
    })
  );
export default SvgThumbsUp20Px;
